export default "__VITE_ASSET__BZhrX7rX__"